import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [route, setRoute] = useState("");
  return (
    <nav>
      <Link
        to="/"
        onClick={() => setRoute("about")}
        style={
          route === "about"
            ? {
                transform: "translate(4px, 4px)",
                boxShadow: "0px 0px",
                transition: "transform 0.4s, box-shadow 0.4s",
              }
            : {}
        }
      >
        About
      </Link>
      <Link
        to="/schedule"
        onClick={() => setRoute("schedule")}
        style={
          route === "schedule"
            ? {
                transform: "translate(4px, 4px)",
                boxShadow: "0px 0px",
                transition: "transform 0.4s, box-shadow 0.4s",
              }
            : {}
        }
      >
        Schedule
      </Link>
      <Link
        to="/network"
        onClick={() => setRoute("network")}
        style={
          route === "network"
            ? {
                transform: "translate(4px, 4px)",
                boxShadow: "0px 0px",
                transition: "transform 0.4s, box-shadow 0.4s",
              }
            : {}
        }
      >
        Network
      </Link>
      {/* <Link to="/imprint" onClick={() => setRoute("imprint")} style={route === "imprint" ? {transform: "translate(4px, 4px)", boxShadow: "0px 0px", transition: "transform 0.4s, box-shadow 0.4s"} : {}}>Imprint</Link> */}
    </nav>
  );
};
export default Navbar;
